@if (notificationService.errorModalData(); as errorData) {
  <div
    class="modal fade show d-block"
    tabindex="-1"
    style="background-color: rgba(0, 0, 0, 0.5)"
    aria-modal="true"
    role="dialog"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-danger text-white">
          <h5 class="modal-title text-white">
            <i class="bi bi-exclamation-triangle-fill me-2"></i> {{ errorData.title }}
          </h5>
          <button type="button" class="btn-close btn-close-white" (click)="close()"></button>
        </div>
        <div class="modal-body text-start">
          <p class="mb-3 fw-semibold text-danger fs-6">{{ errorData.message }}</p>

          @if (errorData.errors && errorData.errors.length > 0) {
            <div class="alert alert-danger bg-label-danger border-0 p-3 mb-0">
              <ul class="mb-0 ps-3">
                @for (errItem of errorData.errors; track $index) {
                  <li class="mb-1">
                    @if (errItem.field) {
                      <strong class="me-1">{{ formatFieldName(errItem.field) }}:</strong>
                    }
                    <span>{{ errItem.error }}</span>
                  </li>
                }
              </ul>
            </div>
          }

          @if (errorData.details) {
            <div class="p-2 bg-light rounded font-monospace small text-break mt-2">
              {{ errorData.details }}
            </div>
          }
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="close()">Fechar</button>
        </div>
      </div>
    </div>
  </div>
}
